import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
export { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"; import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { CajaTurnoEdit } from "./editmodal";
import { firstMap } from "keautils";
const EditModal = CajaTurnoEdit;
type Entity = models.CajaTurno;

export interface Props {
    value: Entity[];
    cajas: models.CajaDTO[]
    onChange: (value: Entity[]) => PromiseLike<void>;
    readonly?: boolean;
    idSucursal: number | undefined;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>, cajas: models.CajaDTO[]): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Rubro", cell: x => ({ data: models.RubroMovimientoCaja[x.RubroCaja] }) },
        { title: "Caja", cell: x => ({ data: firstMap(cajas, y => y.IdRegistro == x.IdCaja, y => y.Nombre) }) }
    ];
}

/**
* Listado de CajaTurno
*/
class CajaTurnoListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, {
            idSucursal: this.props.idSucursal
        }, {} as Entity);;
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;

            await this.props.onChange([...oldList, newItem]);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, {
            idSucursal: this.props.idSucursal
        }, item);
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;

            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?");
        if (ok) {
            const oldList = this.props.value;

            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar }, this.props.cajas!);
        return (
            <div>
                <kea.Title titulo="Asignación de cajas" onAgregar={this.handleOnAgregar} size="h4" />

                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda />
                {this.modals.component}
            </div>
        );
    }
}
export const CajaTurnoList = kea.mapProps(componentToRx(CajaTurnoListNoRx), x => ({ cajas: observeResource(resources.Caja.query), ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/turnos/edit/cajas/list.tsx